import { useToast } from "@chakra-ui/react";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import moment from "moment";
import {
  getCoinHistoryAPI,
  getUsersByTypeAPI,
  searchUserAPI,
} from "../service/AuthService";
import { useLocation, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import { PERMISSION_MAP } from "../utils/constants";
import { useSelector } from "react-redux";
export default function AccountStatement() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [type, setType] = useState("ALL");
  const location = useLocation();
  console.log(location)
  const [filter, setFilter] = useState(null);
  const [commissionFilter] = useState([
    "commission",
    "loss",
    "profit",
    "winner",
  ]);
  const [userName, setUserName] = useState(
    location.state?.userName
      ? {
        value: location.state?.userName,
        label: location.state?.userName,
      }
      : null
  );
  const [fromDate, setFromDate] = useState(
    moment()
      .subtract(7, "d")
      .format("YYYY-MM-DD")
  );
  const selectedData = location?.state; // your JSON object

  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [search, setSearch] = useState("");
  const [userType, setUserType] = useState(selectedData?.userType?.toUpperCase());
  const [users, setUsers] = useState([]);

  const { id } = useParams();
  const toast = useToast();
  const getAccountStatement = async () => {
    let payload = {
      startDate: new Date(fromDate).getTime(),
      endDate: new Date(toDate).getTime(),
    };

    const { response, message, code } = await getCoinHistoryAPI(
      id ? id : userName?.value,
      payload.startDate,
      payload.endDate
    );
    if (code == 200) {
      setData(
        response.coinHistory.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        )
      );
    } else {
      toast({
        title: "Error",
        description: response,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };
  const getUsersByType = async () => {
    const { response, code } = await getUsersByTypeAPI(
      userType?.toLocaleUpperCase()
    );
    if (code === 200) {
      setUsers(response?.users);
    }
  };
  useEffect(() => {
    getUsersByType();
  }, [userType]);
  const filterObjectsByKeywords = (array, keywords) => {
    if (!keywords) return array;
    if (keywords == "ALL") return array;
    if (keywords == "ACCOUNT")
      return array.filter((obj) => {
        return !commissionFilter?.some((keyword) =>
          obj.description.toLowerCase().includes(keyword.toLowerCase())
        );
      });
    return array.filter((obj) => {
      return keywords?.some((keyword) =>
        obj.description.toLowerCase().includes(keyword.toLowerCase())
      );
    });
  };
  useEffect(() => {
    if (id) {
      getAccountStatement();
    }
    if (type == "LIMIT") {
      setFilter("ACCOUNT");
    } else if (type == "ALL") {
      setFilter("ALL");
    } else {
      setFilter([type]);
    }
  }, [page, limit, type, userName, fromDate, toDate, search]);
  const userData = useSelector((state) => state.account.userData);

  return (
    <>
      <div
        className="content-wrapper">

        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Account Statement</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Account Statement</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <div
                  _ngcontent-ng-c219872124=""
                  className="Super_master_details_section agentledger_block"
                >
                  <form
                    _ngcontent-ng-c219872124=""
                    noValidate=""
                    className="row g-lg-3 g-2 align-items-end ng-untouched ng-pristine ng-valid" style={{ gap: "6px" }}
                  >
                    <div
                      _ngcontent-ng-c219872124=""
                      className="col-6 col-md-4 col-lg-3"
                    >
                      <div
                        _ngcontent-ng-c219872124=""
                        className="input_block position-relative"
                      >
                        <label _ngcontent-ng-c219872124="">User Type</label>
                        <ReactSelect
                          isDisabled={true}
                          options={PERMISSION_MAP[
                            userData?.userType?.toUpperCase()
                          ]?.map((type) => ({
                            label: type,
                            value: type,
                          }))}
 
                          value={
                            PERMISSION_MAP[userData?.userType?.toUpperCase()]
                              ?.map((type) => ({ label: type, value: type }))
                              ?.find(
                                (opt) =>
                                  opt.value ===
                                  (selectedData?.userType || userData?.userType)?.toUpperCase()
                              ) || null
                          }
                          // onChange={(e) => setUserType(e.value)}
                        />
                        {/**/}
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c219872124=""
                      className="col-6 col-md-4 col-lg-3"
                    >
                      <div
                        _ngcontent-ng-c219872124=""
                        className="input_block position-relative"
                      >
                        <label _ngcontent-ng-c219872124="">User</label>
                        <ReactSelect
                        isDisabled={true}
                          options={
                            users?.map((user) => ({
                              label: `${user.userName} - ${user.name}`,
                              value: user.userId,
                            })) || []
                          }
                          value={
                            users?.length && selectedData?.userName
                              ? (() => {
                                const selected = users.find(
                                  (u) => u.userName === selectedData.userName
                                );
                                return selected
                                  ? {
                                    label: `${selected.userName} - ${selected.name}`,
                                    value: selected.userId,
                                  }
                                  : null;
                              })()
                              : null
                          }
                          // onChange={(e) => setUserName(e)}
                        />

                        {/**/}
                      </div>
                    </div>

                    <div
                      _ngcontent-ng-c219872124=""
                      className="col-6 col-md-3 col-lg-2"
                    >
                      <div _ngcontent-ng-c219872124="" className="input_block">
                        <label _ngcontent-ng-c219872124="" htmlFor="type">
                          Date From
                        </label>
                        <input
                          _ngcontent-ng-c219872124=""
                          type="date"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                          formcontrolname="FromDate"
                          className="form-control ng-untouched ng-pristine ng-valid"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c219872124=""
                      className="col-6 col-md-3 col-lg-2"
                    >
                      <div _ngcontent-ng-c219872124="" className="input_block">
                        <label _ngcontent-ng-c219872124="" htmlFor="type">
                          Date To
                        </label>
                        <input
                          _ngcontent-ng-c219872124=""
                          type="date"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                          formcontrolname="EndDate"
                          className="form-control ng-untouched ng-pristine ng-valid"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c219872124=""
                      className="col-6 col-md-4 col-lg-3"
                    >
                      <div _ngcontent-ng-c219872124="" className="input_block">
                        <label _ngcontent-ng-c219872124="" htmlFor="type">
                          Report Type{" "}
                        </label>
                        <select
                          _ngcontent-ng-c219872124=""
                          formcontrolname="reportType"
                          onChange={(e) => setType(e.target.value)}
                          className="form-control form-select ng-untouched ng-pristine ng-valid"
                        >
                          <option _ngcontent-ng-c219872124="" value="ALL">
                            Select Type
                          </option>
                          <option _ngcontent-ng-c219872124="" value="ALL">
                            All
                          </option>
                          <option _ngcontent-ng-c219872124="" value={"LIMIT"}>
                            Limit
                          </option>
                          <option _ngcontent-ng-c219872124="" value={3}>
                            commission
                          </option>
                          <option _ngcontent-ng-c219872124="" value={4}>
                            status
                          </option>
                          <option _ngcontent-ng-c219872124="" value={5}>
                            bet status
                          </option>
                        </select>
                      </div>
                    </div>

                    <div
                      _ngcontent-ng-c219872124=""
                      className="col-6 col-md-6 col-lg-2"
                    >
                      <div _ngcontent-ng-c219872124="" className="input_block d-flex" style={{ gap: "6px" }}>
                        <button
                          _ngcontent-ng-c219872124=""
                          type="button"
                          onClick={getAccountStatement}
                          className="btn btn-primary"
                          disabled=""
                        >
                          Show Reports
                        </button>
                        <button
                          _ngcontent-ng-c219872124=""
                          type="button"
                          onClick={() => {
                            window.location.href = "/report/account_statement";
                          }}
                          className="btn btn-danger"
                          disabled=""
                          style={{ color: "white" }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>

                    {/* </div> */}
                  </form>
                </div>
              </div>
              <div className="card-body">
                <div _ngcontent-ng-c219872124="" className="custom_table">
                  <div _ngcontent-ng-c219872124="" className="table-responsive">
                    <table _ngcontent-ng-c219872124="" className="table table-bordered table-striped dataTable no-footer">
                      <thead _ngcontent-ng-c219872124="">
                        <tr _ngcontent-ng-c219872124="">
                          {data &&
                            data.length > 0 &&
                            Object.keys(data[0]).map((key, index) =>
                              key !== "id" && 
                             key != "userId" &&
                             key != "previousBalance" &&
                             key != "fixedLimit" &&
                             key != "marketId" ? (
                                <th _ngcontent-ng-c219872124="" key={index}>
                                  {key === "updatedBalance" ? "BALANCE" : key?.toUpperCase()}
                                </th>
                              ) : null
                            )}
                        </tr>
                      </thead>
                      <tbody
                        style={{
                          backgroundColor: "white",
                        }}
                        _ngcontent-ng-c219872124=""
                      >
                        {data &&
                          data.length > 0 &&
                          filterObjectsByKeywords(data, filter).map((item, index) => {
                            return (
                              <tr _ngcontent-ng-c219872124="" key={index}>
                                {Object.keys(item).map((key, index) =>
                                  key !== "id" &&
                                    key !== "userId" &&
                                    key !== "previousBalance" &&
                                    key !== "fixedLimit" &&
                                    key != "marketId" ? (
                                    <td _ngcontent-ng-c219872124="" key={index}>
                                      {key == "createdAt"
                                        ? moment(item[key] + "Z").format(
                                          "YYYY-MM-DD HH:mm:ss"
                                        )
                                        : item[key]}
                                    </td>
                                  ) : null
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </>
  );
}
